import React from "react";

import {
  IonCol,
  IonRow,
  IonGrid,
  IonAvatar,
  IonText,
  IonSkeletonText
} from "@ionic/react";

import { Organization as OrganizationInterface } from "../../interfaces/organization";

import Avatar from "../../assets/avatar.svg";

import "./Organization.css";

const Organization: React.FC<{
  organization: OrganizationInterface;
  loading: boolean;
}> = ({ organization, loading }) => {
  return (
    <IonGrid className="ui-organization">
      <IonRow className="ion-justify-content-center">
        <IonCol className="ui-organization-row" size="12">
          <IonAvatar>
            {loading ? (
              <IonSkeletonText animated style={{ width: "100%" }} />
            ) : (
              <img src={organization.image || Avatar} alt={organization.name} />
            )}
          </IonAvatar>
          <IonText>
            {loading ? (
              <IonSkeletonText animated style={{ width: 150, height: 20 }} />
            ) : (
              organization.name
            )}
          </IonText>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default Organization;
